import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { Place } from "../types";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { getPlace } from "@/services/place";

export function useGetPlace(
  placeId: number,
  options?: UseQueryOptions<unknown, Error, Place | undefined>,
) {
  const fetchPlace = async () => {
    return await getPlace(placeId);
  };

  return useQuery<unknown, Error, Place | undefined>({
    queryKey: ["place", placeId],
    queryFn: fetchPlace,
    ...options,
    retry(failureCount, error) {
      if (error instanceof Error && error.message === "place not found") {
        return false;
      }
      return failureCount < 3;
    },
  });
}
